import axios from "axios"
export default class Search {
    constructor () {
        this.addSearchHTML()
        this.searchOverlay = document.querySelector(".search-overlay")
        this.closeButton = document.querySelector(".search-overlay__closeButton")
        this.searchInput = document.querySelector(".search-overlay__input")
        this.resultDiv = document.querySelector(".search-overlay__result")
        this.isOpen = false
        this.isSpinnerActive = false
        this.previousValue
        this.typingTimer
        this.event()
    }
    //event
    event () {
        document.querySelectorAll("#desktop-search, #mobile-search").forEach( button => {
            button.addEventListener("click",()=>this.openSearchbar())
        })
        this.closeButton.addEventListener("click", ()=> this.closeSearchbar())
        document.addEventListener("keydown",e=> this.keyDispatcher(e))
        this.searchInput.addEventListener("keyup", () => this.typeLogic())
    }
    //method
    async getResults () {
        try {
            const results = await axios.get(purseData.root_url + "/wp-json/purse-world/v1/search?term=" +this.searchInput.value)
            const response = results.data
            this.resultDiv.innerHTML = `
            <div class="md:w-2/3 pb-6">
                <h2 class="search-overlay__title text-[#0D3B66]">Products</h2>
                ${response.products.length ?  "<ul class='grid gap-x-6 gap-y-10 grid-cols-2 md:grid-cols-4 xl:gap-x-8 mb-10'>" : "<p class='pt-5 text-base'>No products matches this search</p>" }
                ${response.products.map(product => `
                    <li class="flex flex-row space-x-2 py-2 group">
                        <a href="${product.permalink}">
                            <!--Img container-->
                            <img class="skeleton w-[210px] aspect-square rounded-md object-cover group-hover:opacity-75" src="${product.thumbnail}" alt="<?php the_title(); ?>">
                            <!--product title-->
                            <h3 class="font-sans mt-4 text-base text-gray-700 text-left group-hover:text-secondary">${product.title}</h3>
                            <!--price container-->
                            <div class="flex">
                                <p class="font-medium text-gray-900 trending-product-price">${product.price}</p>
                            </div>
                        </a>
                    </li>
                `).join("")}
                ${response.products.length ?  `</ul><a href='${purseData.root_url + "?s=" + this.searchInput.value + "&post_type=product"}' class='hover:underline flex items-center text-lg text-blue-500'>Check all the product results<svg class="text-blue-500" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="m700-300-57-56 84-84H120v-80h607l-83-84 57-56 179 180-180 180Z"/></svg></a>` : "" }
            </div>
            <div class="md:w-1/3 pb-6 mb-10">
                <h2 class="search-overlay__title  text-[#0D3B66]">Blogs</h2>
                ${response.posts.length ? "<ul>"  : "<p class='pt-5 text-base'>No blog matches this search</p>"}
                ${response.posts.map(post => `
                <li class="font-head tracking-wider transition duration-100 text-xl py-4 border-b border-dotted border-[#DEDEDE]">
                <a class="text-basel hover:text-primary leading-7 underline underline-offset-4 lowercase" href="${post.permalink}">${post.title}</a></li>
                `).join("")}
                ${response.posts.length ? `</ul><a href='${purseData.root_url + "?s=" + this.searchInput.value + "&post_type=post"}' class="hover:underline flex items-center text-lg text-blue-500">Check all the post results<svg class="text-blue-500" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="m700-300-57-56 84-84H120v-80h607l-83-84 57-56 179 180-180 180Z"/></svg></a>`  : ""}
            </div>`
        }catch(e) {
            console.error(e)
        }
        this.isSpinnerActive = false
    }
    typeLogic () {
        if (this.searchInput.value != this.previousValue ) {
            clearTimeout(this.typingTimer)
            if (this.searchInput.value) {
                if (!this.isSpinnerActive) {
                    this.resultDiv.innerHTML = `<div class="border-4 w-10 h-10 rounded-full border-t-primary border-gray-300 animate-spin"></div>`
                    this.isSpinnerActive = true
                }
               this.typingTimer = setTimeout(()=>this.getResults(), 750)
            }else {
                this.resultDiv.innerHTML = ``
                this.isSpinnerActive = false
            }
        }
        this.previousValue = this.searchInput.value
    }
    keyDispatcher(e) {
        if (e.keyCode === 83 && document.activeElement.tagName != "INPUT" && document.activeElement.tagName != "TEXTAREA")  this.openSearchbar()
        if (e.keyCode === 27 && document.activeElement.tagName != "INPUT" && document.activeElement.tagName != "TEXTAREA")  this.closeSearchbar()
    }
    openSearchbar() {
        if (!this.isOpen && this.searchOverlay.classList.contains("hidden")) {
            this.isOpen = true
            this.searchOverlay.classList.remove("hidden")
            setTimeout(()=> this.searchOverlay.classList.add("search-overlay__active"), 20)
            document.body.classList.add("overflow-hidden")
            setTimeout(()=> this.searchInput.focus(), 200)
            this.searchInput.value = ""
        }
    }
    closeSearchbar() {
        if (this.isOpen) {
            this.isOpen = false
            document.body.classList.remove("overflow-hidden")
            this.searchOverlay.classList.remove("search-overlay__active")
            setTimeout(()=> this.searchOverlay.classList.add("hidden"), 300)
        }
    }
    addSearchHTML () {
        document.body.insertAdjacentHTML("beforeend", `
        <div class="hidden overflow-y-auto search-overlay fixed inset-0 bg-[rgba(255,255,255,0.96)] h-screen z-[6000] transition duration-300 opacity-0 scale-[1.09]">
            <div class="search-overlay__top bg-[rgba(0,0,0,0.12)] p-4">
                <div class="container mx-auto flex items-center flex-row">
                    <svg class="text-primary w-10 h-10 md:w-10 md:h-10 lg:w-12 lg:h-12" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg>
                    <form action='${purseData.root_url}' class="flex-1 m-0">
                    <input name="s" class="search-overlay__input w-full focus:outline-none text-primary text-base md:text-2xl lg:text-4xl bg-transparent" type="text" placeholder="What are you looking for?">
                    <input type="hidden" name="post_type" value="product">
                    </form>
                    <button class="search-overlay__closeButton hover:opacity-80 transition duration-200 w-8 h-8 lg:w-10 lg:h-10"><svg class="bg-primary rounded-md" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#fff"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg></button>
                    </div>
            </div>
            <div class="search-overlay__result flex flex-col md:space-x-10 lg:space-x-14 xl:space-x-20 md:flex-row justify-between container mx-auto p-4">
            </div>
        </div>
        `)
    }
}